/** @jsxImportSource @emotion/react */

import "swiper/css";

import {
  ImageGuideMemberVip,
  ImageUpLvMemberVip,
} from "assets/desktop/images/member-vip";
import ImageVipBanner from "assets/mobile/images/member-vip/vip_banner.jpg";
import HelmetCustom from "components/common/HelmetCustom";
import MDrawer from "components/mobile/MDrawer";
import { PATH } from "constants/path";
import { ListBenefitVip } from "pages/desktop/VipDetails";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { VipDetailsMobileStyle } from "./style.index";
import SwiperVipDetailsM from "./SwiperVipDetails";

const VipDetailMobile = () => {
  const navigate = useNavigate();
  const [isOpenDraw, setIsOpenDraw] = useState<boolean>(true);

  const handleClose = () => {
    setIsOpenDraw(false);
    navigate(PATH.Home);
  };

  return (
    <>
      <HelmetCustom title="Chi tiết VIP" />
      <MDrawer
        className="drawer__member-vip"
        title={"Chi tiết VIP"}
        isOpen={isOpenDraw}
        onClose={handleClose}
      >
        <div css={VipDetailsMobileStyle.wrapper}>
          <div css={VipDetailsMobileStyle.banner}>
            <img src={ImageVipBanner} alt="" />
          </div>
          <div css={VipDetailsMobileStyle.swiper}>
            <SwiperVipDetailsM />
            <div css={VipDetailsMobileStyle.private}>
              <span>Đặc quyền riêng tư</span>
            </div>

            <div css={VipDetailsMobileStyle.groupBenefit}>
              {ListBenefitVip.map((item, index) => (
                <div key={index} css={VipDetailsMobileStyle.itemBenefit}>
                  <div css={VipDetailsMobileStyle.textBox}>
                    <span>{item.name}</span>
                  </div>
                  <img src={item.image} alt="" />
                </div>
              ))}
            </div>
          </div>
          <div css={VipDetailsMobileStyle.mainContent}>
            <img src={ImageGuideMemberVip} alt="" />
            <img src={ImageUpLvMemberVip} alt="" />
          </div>
        </div>
      </MDrawer>
    </>
  );
};

export default VipDetailMobile;
